/* Go Lime JS — cart/footer/tabs/Judge.me enhancements (consolidated from portlandia_header.liquid) */

// PES Supply Critical Fixes JS - August 2026
// Consolidates: preconnect injection, Apollo.io removal, AVADA hide, duplicate H1 removal, Price Match badge injection

(function() {
  'use strict';

  // === 1. INJECT PRECONNECT HINTS ===
  const domains = [
    'cdn.shopify.com',
    'static.klaviyo.com',
    'googletagmanager.com',
    'cdn.jsdelivr.net',
    'connect.facebook.net',
    'clarity.ms',
    'facebook.com'
  ];
  domains.forEach(function(domain) {
    if (!document.querySelector('link[rel="preconnect"][href*="' + domain + '"]')) {
      var link = document.createElement('link');
      link.rel = 'preconnect';
      link.href = 'https://' + domain;
      link.crossOrigin = 'anonymous';
      document.head.appendChild(link);
    }
  });

  // === 2. REMOVE APOLLO.IO TRACKER ===
  var apolloScripts = document.querySelectorAll('script[src*="apollo.io"], script[src*="assets.apollo.io"]');
  apolloScripts.forEach(function(script) {
    console.log('[PES Fixes] Removed Apollo.io tracker');
    script.remove();
  });

  // Also remove the Apollo.io image pixel if present
  var apolloPixels = document.querySelectorAll('img[src*="apollo.io"], img[src*="assets.apollo.io"]');
  apolloPixels.forEach(function(img) {
    img.remove();
  });

  // === 3. HIDE AVADA LOADING SCREEN ===
  function hideAvadaLoader() {
    var loaders = document.querySelectorAll('.Avada-LoadingScreen, .avada-loading-screen, #Avada-LoadingScreen');
    loaders.forEach(function(el) {
      el.style.display = 'none';
      el.style.visibility = 'hidden';
      el.style.opacity = '0';
      el.style.pointerEvents = 'none';
    });
  }
  hideAvadaLoader();
  // Also hide on DOM ready and after a delay
  document.addEventListener('DOMContentLoaded', hideAvadaLoader);
  setTimeout(hideAvadaLoader, 500);
  setTimeout(hideAvadaLoader, 2000);

  // === 4. REMOVE DUPLICATE H1 ON HOMEPAGE ===
  if (document.body.classList.contains('template-index')) {
    var h1s = document.querySelectorAll('h1');
    if (h1s.length > 1) {
      for (var i = 1; i < h1s.length; i++) {
        // If it's in a nav or header, convert to H2
        if (h1s[i].closest('nav, header, .dsk_nav, .header')) {
          var h2 = document.createElement('h2');
          h2.innerHTML = h1s[i].innerHTML;
          h2.className = h1s[i].className;
          h1s[i].parentNode.replaceChild(h2, h1s[i]);
          console.log('[PES Fixes] Converted duplicate H1 to H2');
        } else {
          // Otherwise just remove it
          h1s[i].remove();
          console.log('[PES Fixes] Removed duplicate H1');
        }
      }
    }
  }

  // === 5. FIX TAB CLASS TYPO ===
  var typoElements = document.querySelectorAll('.first-block-tabing-iconss');
  typoElements.forEach(function(el) {
    el.classList.remove('first-block-tabing-iconss');
    el.classList.add('first-block-tabbing-icons');
  });

  // === 6. PRICE MATCH GUARANTEE BADGE INJECTION ===
  function injectPriceMatchBadge() {
    // Only on product pages
    if (!document.body.classList.contains('template-product')) return;

    var productForm = document.querySelector('.product-form, form[action*="/cart/add"], .product-single__meta');
    if (!productForm) return;

    // Check if badge already exists
    if (document.querySelector('.pes-price-match-badge')) return;

    // Try to get competitor URL from metafield
    var competitorUrl = null;
    var metafieldEl = document.querySelector('[data-metafield*="competitor_url"], meta[name="pes.competitor_url"]');
    if (metafieldEl) {
      competitorUrl = metafieldEl.getAttribute('content') || metafieldEl.getAttribute('data-metafield');
    }

    // Create badge
    var badge = document.createElement('div');
    badge.className = 'pes-price-match-badge';
    badge.innerHTML = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>' +
      '<span>Price Match Assurance — Found it cheaper? We\'ll meet it or beat it.' +
      (competitorUrl ? ' <a href="' + competitorUrl + '" target="_blank" rel="noopener">View competitor pricing</a>' : '') +
      '</span>';

    // Insert after price or at top of product form
    var priceEl = document.querySelector('.price, .product-price, [data-price]');
    if (priceEl && priceEl.parentNode) {
      priceEl.parentNode.insertBefore(badge, priceEl.nextSibling);
    } else {
      productForm.insertBefore(badge, productForm.firstChild);
    }
  }

  // Run on DOM ready and on Shopify section load
  document.addEventListener('DOMContentLoaded', injectPriceMatchBadge);
  document.addEventListener('shopify:section:load', injectPriceMatchBadge);

  // === 7. EAGER-LOAD ABOVE-FOLD IMAGES ===
  function fixLazyLoadedImages() {
    var aboveFoldImages = document.querySelectorAll('.hero-section img, .patriotic-hero img, .dsk_nav img, .homepage-hero img');
    aboveFoldImages.forEach(function(img) {
      if (img.getAttribute('loading') === 'lazy') {
        img.setAttribute('loading', 'eager');
        img.setAttribute('fetchpriority', 'high');
      }
    });
  }
  document.addEventListener('DOMContentLoaded', fixLazyLoadedImages);

  // === 8. COOKIE BANNER BODY PADDING ===
  function addCookieBannerPadding() {
    var cookieBanner = document.querySelector('.cc-window, .cookie-consent-banner, #cookie-banner, .CookieConsent');
    if (cookieBanner && cookieBanner.offsetHeight > 0) {
      document.body.classList.add('has-cookie-banner');
    }
  }
  setTimeout(addCookieBannerPadding, 1000);
  setTimeout(addCookieBannerPadding, 3000);

  
// === JSON-LD STRUCTURED DATA INJECTION ===
function injectJSONLD() {
  var org = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "PES Supply",
    "url": "https://www.portlandiaelectric.supply",
    "logo": "https://www.portlandiaelectric.supply/cdn/shop/files/pes-logo.png",
    "description": "PES Supply is a leading distributor of solar equipment, electrical supplies, and energy storage solutions with 50,000+ SKUs and 169 authorized brands.",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "San Antonio",
      "addressRegion": "TX",
      "addressCountry": "US"
    },
    "sameAs": [
      "https://www.facebook.com/portlandiaelectric",
      "https://www.linkedin.com/company/portlandia-electric-supply"
    ]
  };
  var script = document.createElement('script');
  script.type = 'application/ld+json';
  script.text = JSON.stringify(org);
  document.head.appendChild(script);
}
injectJSONLD();

// === EAGER LOAD ABOVE-FOLD IMAGES ===
function fixLazyLoading() {
  var aboveFoldImages = document.querySelectorAll('.homepage-hero img, .dsk_nav img, .main_header_section img');
  aboveFoldImages.forEach(function(img) {
    if (img.getAttribute('loading') === 'lazy') {
      img.setAttribute('loading', 'eager');
      img.setAttribute('fetchpriority', 'high');
    }
  });
}
fixLazyLoading();
setTimeout(fixLazyLoading, 500);

// === REMOVE DUPLICATE EMAIL ELEMENTS ===
function fixEmailOverlap() {
  var emails = document.querySelectorAll('.email_svg_tablet, .mbl_view_email');
  emails.forEach(function(el) { el.style.display = 'none'; });
}
fixEmailOverlap();
setTimeout(fixEmailOverlap, 1000);


// === NAV BAR STYLE ENFORCEMENT ===
function enforceNavBarStyles() {
  var nav = document.querySelector('.dsk_nav');
  if (nav) {
    nav.style.backgroundColor = '#0f1e2d';
    nav.style.color = '#fff';
    nav.style.borderTop = 'none';
    nav.style.borderBottom = 'none';
    nav.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
  }
  // Also style the menu items
  var menuItems = document.querySelectorAll('.dsk_nav_mega_menu, .dsk_mm_list_menu');
  menuItems.forEach(function(item) {
    if (item.classList.contains('dsk_nav_mega_menu')) {
      item.style.backgroundColor = '#11B67B';
      item.style.color = '#fff';
    }
  });
}
enforceNavBarStyles();
setTimeout(enforceNavBarStyles, 500);
setTimeout(enforceNavBarStyles, 1500);
// Re-enforce after AVADA/spa scripts load
window.addEventListener('load', function() {
  setTimeout(enforceNavBarStyles, 100);
});


// === PRODUCT SCHEMA JSON-LD ===
function injectProductSchema() {
  if (!window.location.pathname.includes('/products/')) return;
  var productJson = document.querySelector('script[type="application/json"][data-product-json]');
  if (!productJson) {
    // Try to extract from page
    var title = document.querySelector('h1.product-title, h1.product__title, .product-single__title, h1');
    var price = document.querySelector('.price-item, .product__price, .price__regular .price-item');
    if (title) {
      var schema = {
        "@context": "https://schema.org/",
        "@type": "Product",
        "name": title.textContent.trim(),
        "brand": {"@type": "Brand", "name": "PES Supply"},
        "offers": {
          "@type": "Offer",
          "url": window.location.href,
          "priceCurrency": "USD",
          "availability": "https://schema.org/InStock"
        }
      };
      if (price) {
        var priceText = price.textContent.replace(/[^0-9.]/g, '');
        if (priceText) schema.offers.price = priceText;
      }
      var script = document.createElement('script');
      script.type = 'application/ld+json';
      script.text = JSON.stringify(schema);
      document.head.appendChild(script);
    }
  }
}
injectProductSchema();

// === BREADCRUMB JSON-LD ===
function injectBreadcrumbSchema() {
  var breadcrumbs = document.querySelectorAll('.breadcrumb a, .breadcrumbs a, nav[aria-label="breadcrumb"] a');
  if (breadcrumbs.length < 2) return;
  var items = [];
  breadcrumbs.forEach(function(crumb, i) {
    items.push({
      "@type": "ListItem",
      "position": i + 1,
      "name": crumb.textContent.trim(),
      "item": crumb.href
    });
  });
  var schema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items
  };
  var script = document.createElement('script');
  script.type = 'application/ld+json';
  script.text = JSON.stringify(schema);
  document.head.appendChild(script);
}
injectBreadcrumbSchema();

// === TRUST BADGES ON PRODUCT PAGES ===
function injectTrustBadges() {
  if (!window.location.pathname.includes('/products/')) return;
  var addToCartBtn = document.querySelector('button[name="add"], .product-form__submit, .add-to-cart-btn');
  if (!addToCartBtn) return;
  var container = addToCartBtn.closest('form') || addToCartBtn.parentElement;
  if (!container || container.querySelector('.pes-trust-badges')) return;
  
  var badges = document.createElement('div');
  badges.className = 'pes-trust-badges';
  badges.style.cssText = 'display:flex;gap:12px;flex-wrap:wrap;margin:16px 0;padding:12px;background:#f8f9fa;border-radius:8px;border:1px solid #e5e7eb;';
  badges.innerHTML = [
    {icon: '✓', text: 'Authorized Dealer', color: '#11B67B'},
    {icon: '⚡', text: 'Fast Shipping', color: '#30ab68'},
    {icon: '🛡', text: 'Full Warranty', color: '#0f1e2d'},
    {icon: '💬', text: 'Expert Support', color: '#11B67B'}
  ].map(function(b) {
    return '<div style="display:flex;align-items:center;gap:6px;font-size:13px;font-weight:600;color:' + b.color + '">' +
           '<span style="font-size:16px">' + b.icon + '</span>' + b.text + '</div>';
  }).join('');
  container.appendChild(badges);
}
injectTrustBadges();
setTimeout(injectTrustBadges, 1000);
setTimeout(injectTrustBadges, 2000);

// === COLLECTION FILTER DUPLICATE FIX ===
function fixCollectionFilterDuplicates() {
  if (!window.location.pathname.includes('/collections/')) return;
  var filterLabels = document.querySelectorAll('.filter-option-label, .globo-filter-item-label, a[href*="filter"]');
  var seen = {};
  filterLabels.forEach(function(label) {
    var text = label.textContent.trim().toLowerCase();
    var count = (text.match(/\((\d+)\)/) || [])[1];
    var key = text.replace(/\s*\(\d+\)/, '').replace(/s$/, '');
    if (seen[key] && parseInt(count || 0) < parseInt(seen[key].count || 0)) {
      label.closest('li, .globo-filter-item, .filter-option').style.display = 'none';
    } else {
      seen[key] = {count: count, element: label};
    }
  });
}
fixCollectionFilterDuplicates();
setTimeout(fixCollectionFilterDuplicates, 1500);

// =====================================================================
// GO LIME DESIGN SYSTEM -- JS ADDITIONS (via portlandia_header.liquid)
// =====================================================================

// === CART PAGE: inject trust row + cross-sell rail (Go Lime cart.html) ===
function pesGolimeCartEnhance() {
  if (!window.location.pathname.includes('/cart')) return;

  // Trust row under checkout button
  var checkoutBtn = document.querySelector('button[name="checkout"], .cart__checkout-button');
  if (checkoutBtn && !document.querySelector('.pes-cart-trust-row')) {
    var trustRow = document.createElement('div');
    trustRow.className = 'pes-cart-trust-row';
    trustRow.innerHTML =
      '<span>Secure Checkout</span>' +
      '<span>SSL Encrypted</span>' +
      '<span>Easy Returns</span>';
    var footer = checkoutBtn.closest('.cart__footer, .cart-summary, form') || checkoutBtn.parentElement;
    if (footer) footer.appendChild(trustRow);
  }

  // Cross-sell rail "You might also need" (only if cart has items and rail not already present)
  var cartItems = document.querySelectorAll('.cart-item, tr.cart-item');
  var itemsContainer = document.querySelector('.cart__items, .cart-items, table.cart-items');
  if (cartItems.length > 0 && itemsContainer && !document.querySelector('.pes-cart-crosssell')) {
    fetch('/recommendations/products.json?product_id=' + getFirstCartProductId() + '&limit=4&intent=related')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        var products = (data && data.products) || [];
        if (!products.length) return;
        var rail = document.createElement('div');
        rail.className = 'pes-cart-crosssell';
        var grid = products.map(function (p) {
          var img = (p.featured_image && (p.featured_image.url || p.featured_image)) || (p.images && p.images[0]) || '';
          var price = p.price ? '$' + (p.price / 100).toFixed(2) : '';
          return '<a class="pes-cart-crosssell__card" href="' + p.url + '">' +
            (img ? '<img src="' + img + '" width="120" height="120" loading="lazy" alt="' + p.title + '">' : '') +
            '<div class="title" style="font-size:13px;font-weight:600;color:#0f1e2d;margin:6px 0 4px;">' + p.title + '</div>' +
            '<div class="price">' + price + '</div>' +
            '</a>';
        }).join('');
        rail.innerHTML = '<h3>You might also need</h3><div class="pes-cart-crosssell__grid">' + grid + '</div>';
        itemsContainer.parentElement.appendChild(rail);
      })
      .catch(function () {});
  }
}

function getFirstCartProductId() {
  var el = document.querySelector('[data-product-id]');
  return el ? el.getAttribute('data-product-id') : '';
}

pesGolimeCartEnhance();
setTimeout(pesGolimeCartEnhance, 1200);
document.addEventListener('cart:updated', pesGolimeCartEnhance);

// === PRODUCT PAGE: wire up click handlers for the EXISTING .pes-pdp-tabs
// markup shipped by a prior agent (pes-pdp-enhanced.js is not linked from
// the header section that actually renders, so the tab buttons currently
// have no click behavior -- only the CSS from pes-pdp-enhanced.css was
// missing/unlinked too, which we restyle above). ===
function pesGolimeWireProductTabs() {
  if (!window.location.pathname.includes('/products/')) return;
  var tabsRoot = document.querySelector('.pes-pdp-tabs');
  if (!tabsRoot || tabsRoot.dataset.pesGolimeWired) return;
  tabsRoot.dataset.pesGolimeWired = 'true';

  var buttons = tabsRoot.querySelectorAll('.pes-pdp-tab-btn');
  buttons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var targetId = btn.getAttribute('data-tab');
      if (!targetId) return;
      buttons.forEach(function (b) { b.classList.remove('active'); });
      tabsRoot.querySelectorAll('.pes-pdp-tab-panel').forEach(function (p) { p.classList.remove('active'); });
      btn.classList.add('active');
      var panel = document.getElementById(targetId);
      if (panel) panel.classList.add('active');
    });
  });

  // Ensure exactly one tab/panel starts active
  if (!tabsRoot.querySelector('.pes-pdp-tab-btn.active') && buttons.length) {
    buttons[0].classList.add('active');
  }
  if (!tabsRoot.querySelector('.pes-pdp-tab-panel.active')) {
    var firstPanel = tabsRoot.querySelector('.pes-pdp-tab-panel');
    if (firstPanel) firstPanel.classList.add('active');
  }
}

pesGolimeWireProductTabs();
setTimeout(pesGolimeWireProductTabs, 800);
setTimeout(pesGolimeWireProductTabs, 1600);

// === FOOTER: inject Go Lime-style contact/trust card if not already present ===
function pesGolimeFooterEnhance() {
  var footer = document.querySelector('footer.cust-mnnew-footer, .cust-mnnewfooter-container');
  if (!footer || document.querySelector('.pes-footer-contact-card')) return;

  var card = document.createElement('div');
  card.className = 'pes-footer-contact-card';
  card.innerHTML =
    '<div>' +
      '<h4>Need help? Talk to our team.</h4>' +
      '<p>Call <a href="tel:+18888760007">(888) 876-0007</a> or email <a href="mailto:sales@pes.supply">sales@pes.supply</a></p>' +
    '</div>' +
    '<div class="pes-footer-social">' +
      '<a href="#" aria-label="Facebook">f</a>' +
      '<a href="#" aria-label="Instagram">i</a>' +
      '<a href="#" aria-label="LinkedIn">in</a>' +
    '</div>';

  var row = document.querySelector('.custmn-newfooter-row');
  var container = document.querySelector('.cust-mnnewfooter-container');
  if (row && row.parentElement) {
    row.parentElement.insertBefore(card, row.nextSibling);
  } else if (container) {
    container.appendChild(card);
  } else {
    footer.appendChild(card);
  }
}

pesGolimeFooterEnhance();
setTimeout(pesGolimeFooterEnhance, 1000);

// === JUDGE.ME: the merchant's Judge.me admin settings define an olive
// "Write a review" button color (jdgmSettings.review_widget_button_color
// = #828410) which Judge.me applies via a :root CSS variable + its own
// late-injected stylesheet, beating simple scoped var overrides. Force
// PES brand colors with an inline style (with priority) on every element
// Judge.me renders, re-applied via MutationObserver since Judge.me's
// widget re-renders asynchronously/on lazy-load. ===
function pesGolimeStyleJudgeMe() {
  // Global CSS variable override, closest thing to a durable fix
  document.documentElement.style.setProperty('--jdgm-primary-color', '#11B67B', 'important');
  document.documentElement.style.setProperty('--jdgm-secondary-color', '#30ab68', 'important');
  document.documentElement.style.setProperty('--jdgm-star-color', '#30ab68', 'important');
  document.documentElement.style.setProperty('--jdgm-write-review-bg-color', '#11B67B', 'important');
  document.documentElement.style.setProperty('--jdgm-write-review-text-color', '#ffffff', 'important');
  document.documentElement.style.setProperty('--jdgm-paginate-color', '#11B67B', 'important');
  document.documentElement.style.setProperty('--jdgm-reviewer-name-color', '#0f1e2d', 'important');

  document.querySelectorAll('.jdgm-write-rev-link, a.jdgm-write-rev-link, button.jdgm-write-rev-link, .jdgm-rev-widg__summary-link').forEach(function (el) {
    el.style.setProperty('background', 'linear-gradient(135deg, #11B67B 0%, #30ab68 100%)', 'important');
    el.style.setProperty('background-color', '#11B67B', 'important');
    el.style.setProperty('color', '#ffffff', 'important');
    el.style.setProperty('border-radius', '999px', 'important');
    el.style.setProperty('border', 'none', 'important');
  });

  document.querySelectorAll('.jdgm-star.jdgm--on, .jdgm-star.jdgm--half').forEach(function (el) {
    el.style.setProperty('color', '#30ab68', 'important');
  });

  document.querySelectorAll('.jdgm-paginate__page--current').forEach(function (el) {
    el.style.setProperty('background-color', '#11B67B', 'important');
    el.style.setProperty('color', '#ffffff', 'important');
  });
}

pesGolimeStyleJudgeMe();
setTimeout(pesGolimeStyleJudgeMe, 500);
setTimeout(pesGolimeStyleJudgeMe, 1000);
setTimeout(pesGolimeStyleJudgeMe, 2000);
setTimeout(pesGolimeStyleJudgeMe, 4000);
document.addEventListener('judgeme:widgetLoaded', pesGolimeStyleJudgeMe);

// Watch for Judge.me injecting/re-rendering its widget DOM asynchronously
// and re-apply our overrides whenever that happens.
var pesJdgmContainer = document.getElementById('judgeme_product_reviews');
if (pesJdgmContainer && window.MutationObserver) {
  var pesJdgmObserver = new MutationObserver(function () {
    pesGolimeStyleJudgeMe();
  });
  pesJdgmObserver.observe(pesJdgmContainer, { childList: true, subtree: true });
  // Stop observing after 20s to avoid indefinite overhead
  setTimeout(function () { pesJdgmObserver.disconnect(); }, 20000);
}

console.log('[PES Fixes] Go Lime design additions loaded (cart/footer/tabs/reviews)');


console.log('[PES Fixes] Critical fixes loaded successfully');
})();

